"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqSortedCategories = void 0;
const _ = require("lodash");
const byPriorityAscending = (categoryA, categoryB) => categoryA.priority - categoryB.priority;
const getUniqSortedCategories = (products) => {
    const allCategories = products
        .filter(product => product.category)
        .map(product => product.category);
    const uniqCategories = _.uniqBy(allCategories, "name");
    const sortedUniq = uniqCategories.sort(byPriorityAscending);
    return sortedUniq;
};
exports.getUniqSortedCategories = getUniqSortedCategories;
//# sourceMappingURL=getUniqSortedCategories.js.map